export default __webpack_public_path__ + "static/media/inverter.d5bd9143.png";